export const CARRIERS_MAP = {
  coordinadora:    { label:'Coordinadora',     color:'#e30613', img:'/coordinadora-logo.webp' },
  servientrega:    { label:'Servientrega',     color:'#00529b', img:'/servientrega-logo.jpg' },
  interrapidisimo: { label:'Inter Rapidísimo', color:'#00a651', img:'/interrapidisimo-logo.jpg' },
  tcc:             { label:'TCC',              color:'#e4002b', img:'/tcc-logo.jpg' },
  envia:           { label:'Envía',            color:'#ff6600', img:'/envia-logo.jpg' },
};

export const PAYMENT_MAP = {
  cod:              { label:'Contra entrega', img:null },
  cash_on_delivery: { label:'Contra entrega', img:null },
  addi:             { label:'Addi',           img:'/payment-logos/addi.png' },
  sistecredito:     { label:'Sistecrédito',   img:'/payment-logos/sistecredito.png' },
};
